import { canv } from "@/canv/global";
import type { WidgetOptions } from "@/shared/types/widgetOptions";
import { useEditButton } from "../../lib/hooks/useEditButton";
import type { SetActiveSubMenu } from "../../types";
import { MenuButtonRenderer } from "./MenuButtonRenderer";

interface MenuEditButtonProps {
    name: WidgetOptions;
    setActiveSubMenu: SetActiveSubMenu;
}

export function MenuEditButton({ name, setActiveSubMenu }: MenuEditButtonProps) {
    const option = useEditButton({ setActiveSubMenu });

    const isVisible =
        canv.canvasController.selected.length === 1 ||
        canv.canvasController.selected[0]?.isItemWrapper();

    if (!isVisible) {
        return null;
    }

    return <MenuButtonRenderer {...option} name={name} />;
}
